export{default as Resize}from"./Resize";